import { Box } from '@mui/material';
import { ResponsiveRadar } from '@nivo/radar';
import ChartSection from '../shared/ChartSection';
import ChartTooltip from '../shared/ChartTooltip';
import useNivoTheme from '../shared/useNivoTheme';

export default function SectorRadar({ data }) {
    const { theme, colors } = useNivoTheme();
    if (!data || data.length === 0) return null;

    const filtered = data.filter(d => d.sector !== 'Unknown');
    if (filtered.length === 0) return null;

    return (
        <ChartSection id="sector-radar" title="How concentrated is congressional trading?" subtitle="Sector allocation — a perfectly diversified portfolio would be a circle. Spikes show overweights.">
            <Box sx={{ height: 400 }}>
                <ResponsiveRadar
                    data={filtered}
                    keys={['pct']}
                    indexBy="sector"
                    maxValue="auto"
                    margin={{ top: 40, right: 80, bottom: 40, left: 80 }}
                    curve="linearClosed"
                    borderWidth={2}
                    borderColor={colors.primary}
                    dotSize={8}
                    dotColor={colors.primary}
                    dotBorderWidth={0}
                    colors={[colors.primary]}
                    fillOpacity={0.15}
                    gridLabelOffset={16}
                    gridShape="circular"
                    theme={{
                        ...theme,
                        dots: { text: { fill: '#9ca3af', fontSize: 10 } },
                    }}
                    sliceTooltip={({ index, data: slice }) => (
                        <ChartTooltip
                            title={index}
                            rows={slice.map(s => ({
                                label: s.id,
                                value: Number(s.value).toFixed(2) + '%',
                                color: s.color,
                            }))}
                        />
                    )}
                />
            </Box>
        </ChartSection>
    );
}
